import React, { Component } from "react";
import styles from './css/HomePage.module.css';

import Navbar from "../CommonComponents/Navbar";
import Footer from "../CommonComponents/Footer";


import ExternalComponiesComp from "./ExternalCompaniesComp";
import PropertyManagementDutiesComp from "./PropertyManagementDutiesComp";
import WhyChooseComp from "./WhyChooseComp";
import MaintainHomeComp from "./MaintainHomeComp";
import HomePageCoverComp from "./HomePageCoverComp";

import HomeBeautyServices from "./HomeBeautyServices";
import ServicePlaces from "./ServicePlaces";
import AppAddComp from "./AppAddComp";
import NewsletterSubCompo from "./NewsletterSubCompo";

export class HomePage extends Component {
  render() {
    return (
      <div className={styles.homePage}>
        <div className={styles.homePageInner}>
          <Navbar></Navbar>
          <HomePageCoverComp></HomePageCoverComp>
          <ExternalComponiesComp></ExternalComponiesComp>
          <PropertyManagementDutiesComp></PropertyManagementDutiesComp>
          <WhyChooseComp></WhyChooseComp>
          <MaintainHomeComp></MaintainHomeComp>
          <HomeBeautyServices></HomeBeautyServices>
          <ServicePlaces></ServicePlaces>
          <AppAddComp></AppAddComp>
          <NewsletterSubCompo></NewsletterSubCompo>
          <Footer></Footer>
        </div>
      </div>
    );
  }
}

export default HomePage;
